import allImgPaths from "assets/images";
import Toast from "components/common/Toast";
import FeteConfirmationModal from "components/common/modal/FeteConfirmationModal";
import useAppState from "context/useAppState";
import { format } from "date-fns";
import { cloneDeep } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteFete, markEventAsFavorite } from "services/event";
import { ROLES } from "utils/constant";

interface FeteCardProps {
  event: any;
  type: any;
  afterDelete: any;
  cardIndex: any;
}

const FeteCard = (props: FeteCardProps) => {
  const { setState: setEventListState, isEventListAPICall } = useAppState("eventList");
  const navigate = useNavigate();
  const { event } = props;
  const [isFavorite, setIsFavorite] = useState(event?.event?.is_favorite || false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLevel, setDeleteLevel] = useState<number>(0)

  const {
    updateBoardCallApiFlag
  } = useAppState('cardWrapper');

  const setFavorite = async (e: any, eventId: any, isFavorite: boolean) => {
    e.stopPropagation()
    setIsFavorite(isFavorite)
    await markEventAsFavorite(eventId, { is_favorite: isFavorite })
  }

  const handleEventImage = (e: any) => {
    e.target.src = allImgPaths.dummyImg;
  }

  const openDeleteModal = (e: any, eventId: any) => {
    e.stopPropagation()
    setDeleteLevel(1)
    setShowDeleteModal(true)
  }

  const handleEmptyClick = (e: any) => {
    e.stopPropagation()
  }

  const levelOneConfirm = () => {
    setDeleteLevel(2)
  }

  const confirmDelete = async () => {
    const eventInfo = event.event
    // console.log({ eventInfo: event.event })
    const payload = {
      id: eventInfo._id,
      name: eventInfo.name,
      is_draft: eventInfo.is_draft
    }

    try {
      const { data } = await deleteFete(payload);
      if (data?.message == 'success') {
        Toast.success('', 'Fete deleted successfully')

        // let eventListState: any = { isEventListAPICall: true }
        // if (props.type == 'upcoming') {
        //   eventListState = { ...eventListState, currentFetesLoading: true }
        // }
        // if (props.type == 'past') {
        //   eventListState = { ...eventListState, pastFeteLoading: true }
        // }

        props.afterDelete({ cardIndex: props.cardIndex })

        // setEventListState(eventListState)

        setShowDeleteModal(false)
      } else {
        setShowDeleteModal(false)
        Toast.error('', 'Failed to delete Fete')
      }
    } catch (error) {
      Toast.error('', 'Failed to delete Fete')
      setShowDeleteModal(false)
    }
  }

  const DraftCard = ({ event }: any) => {
    const objective = event?.event?.objective || "";

    // Determine whether to apply line-clamp-2 class
    const isLongObjective = objective.length > 50; // Adjust the threshold as needed

    // Extract the first 50 characters of the objective
    const shortObjective = isLongObjective ? objective.substring(0, 50) : objective;

    return (
      <>
        {/* Draft Upcoming */}

        <div
          className="w-[280px] cursor-pointer flex-shrink-0 border border-[#D7DFE9] rounded-xl transition-all duration-300 hover:shadow-xl"
          onClick={() => {
            updateBoardCallApiFlag(true);
            navigate(`/fete/${event?.event?._id}`);
          }}
        >
          <div className="w-[280px] h-[202px] rounded-xl relative mb-2 flex-shrink-0">
            <img
              onClick={(e: any) => setFavorite(e, event.event._id, !isFavorite)}
              className='absolute top-2 right-2 w-6 h-6 cursor-pointer'
              src={
                isFavorite ? allImgPaths.heartIconRed : allImgPaths.heartIconWhite
              }
              alt=''
            />
            <img
              className="w-[278px] h-[202px] rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover"
              src={allImgPaths.upcomingDraftIcon}
              alt="img"
            />
          </div>
          <div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
            <p className="text-[#4B3BF7] text-sm font-interSemiBold">{event?.event?.type}</p>
            <span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
              --N/A--
            </span>
          </div>

          <div className="flex items-center justify-between px-3">
            <h3 title={event?.event?.name} className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
              {event?.event?.name}
            </h3>
          </div>

          <p className="text-[#475467] line-clamp-1 px-3 h-7">
            {isLongObjective}
          </p>

          <div className="flex justify-end px-3 pb-1 pt-2">
            {
              event?.event_role?.toLowerCase() === ROLES.OWNER.toLowerCase() &&
              // <img
              //   onClick={(e: any) => openDeleteModal(e, event.event._id)}
              //   className='cursor-pointer hover:bg-[#FFDDDA] rounded p-1 w-7 h-7  relative -top-1.5'
              //   src={allImgPaths.deleteIcon2}>

              // </img>
              <div className="relative group">
                <span className="w-4 inline-block mr-0.5 mb-px">
                  <img className={`cursor-pointer ml-auto`} src={allImgPaths.threeVerticleDotsIcon} alt="" />
                </span>
                <div onClick={(e) => handleEmptyClick(e)} className={`absolute -right-1 -bottom-[2px] w-[188px] rounded-lg shadow-customShadow9 bg-[#fff] pl-2.5 pr-2.5 pt-2 pb-2 z-20 border border-[#eee] group-hover:block hidden cursor-default`}>
                  {
                    event?.event_role?.toLowerCase() === ROLES.OWNER.toLowerCase() ? (
                      <div
                        className="flex items-center gap-x-1.5 cursor-pointer py-1.5 px-1 rounded-lg w-fit"
                        onClick={(e: any) => openDeleteModal(e, event.event._id)}
                      >
                        <img
                          className='w-5 h-5'
                          src={allImgPaths.deleteIcon6}
                          alt=''
                        />
                        <span className="text-[#D92D20] text-base font-interMedium leading-none">
                          Delete
                        </span>
                      </div>
                    ) : (
                      <div className="flex items-center cursor-default py-1.5 px-1 rounded-lg w-fit">
                        <span className="text-base text-[#667085] italic">No Actions Available</span>
                      </div>
                    )
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {
        showDeleteModal &&
        <FeteConfirmationModal
          headerText={'Delete Fete'}
          bodyText={``}
          mainText={`Are you sure you want to delete this fete?`}
          eventInfo={{ name: event.event.name, id: event.event._id }}
          setShowDeleteModal={setShowDeleteModal}
          confirmDelete={confirmDelete}
          level={deleteLevel}
          levelOneConfirm={levelOneConfirm}
        />
      }
      {event.event?.is_draft && <DraftCard event={event} />}

      {!event.event?.is_draft && <div
        className="w-[280px] cursor-pointer border border-[#D7DFE9] rounded-xl transition-all duration-300 hover:shadow-xl"
        onClick={() => {
          updateBoardCallApiFlag(true);
          navigate(`/fete/${event?.event?._id}`);
        }}
      >
        <div className="w-[280px] h-[202px] rounded-xl relative mb-2 ">
          <img
            onClick={(e: any) => setFavorite(e, event.event._id, !isFavorite)}
            className='absolute top-2 right-2 w-6 h-6 cursor-pointer'
            src={
              isFavorite ? allImgPaths.heartIconRed : allImgPaths.heartIconWhite
            }
            alt=''
          />
          <img
            className="rounded-tl-xl rounded-tr-xl rounded-bl-0 rounded-br-0 inline-block object-cover w-[278px] h-[202px]"
            // src={allImgPaths.dummyImg1}
            src={event?.event?.image || allImgPaths.dummyImg}
            alt="img"
            onError={handleEventImage}
          />
        </div>
        <div className="flex items-center justify-between gap-x-2 pb-1.5 px-3">
          <div className="flex items-center justify-between gap-x-2 w-full">
            <p className="text-[#4B3BF7] text-sm font-interSemiBold">{event?.event?.type}</p>
            <span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">{event?.event?.format}</span>
          </div>
        </div>

        <div className="flex items-start justify-between px-3">
          <h3 title={event?.event?.name} className="text-[#101828] text-lg font-interSemiBold pb-1.5 line-clamp-1 max-w-[340px] h-8">
            {event?.event?.name}
          </h3>
        </div>

        <p title={event?.event?.objective} className="text-[#475467] line-clamp-1 px-3 h-7">{event?.event?.objective}</p>
        <div className="px-3 pb-1 pt-2 flex justify-between">
          <p className="text-[#101828] text-xs font-interMedium">{format(event?.event?.start_date, 'MMM dd, yyyy')}</p>
          {
            // <img
            //   onClick={(e: any) => openDeleteModal(e, event.event._id)}
            //   className='cursor-pointer hover:bg-[#FFDDDA] rounded p-1 w-7 h-7  relative -top-1.5'
            //   src={allImgPaths.deleteIcon2}>

            // </img>
            <div className="relative group">
              <span className="w-4 inline-block mr-0.5 mb-px">
                <img className={`cursor-pointer ml-auto`} src={allImgPaths.threeVerticleDotsIcon} alt="" />
              </span>
              <div onClick={(e) => handleEmptyClick(e)} className={`absolute -right-1 -bottom-[2px] w-[188px] rounded-lg shadow-customShadow9 bg-[#fff] pl-2.5 pr-2.5 pt-2 pb-2 z-20 border border-[#eee] group-hover:block hidden cursor-default`}>
                {
                  event?.event_role?.toLowerCase() === ROLES.OWNER.toLowerCase() ? (
                    <div
                      className="flex items-center gap-x-1.5 cursor-pointer py-1.5 px-1 rounded-lg w-fit"
                      onClick={(e: any) => {
                        openDeleteModal(e, event.event._id);
                      }}
                    >
                      <img
                        className='w-5 h-5'
                        src={allImgPaths.deleteIcon6}
                        alt=''
                      />
                      <span className="text-[#D92D20] text-base font-interMedium leading-none">
                        Delete
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-center cursor-default py-1.5 px-1 rounded-lg w-fit">
                      <span className="text-base text-[#667085] italic">No Actions Available</span>
                    </div>
                  )
                }

              </div>
            </div>
          }
        </div>
      </div>}
    </>
  );
}

export default FeteCard;